const baseURL = "https://www.dnd5eapi.co"

export default baseURL